type DEVICE_PLATFORM = 'AOS' | 'IOS' | 'WEB';
const MIN_ANDROID_APP_SCHEME_WORKING_VERSION = '2.5.0';

declare global {
  interface Window {
    AndroidBridge: IAndroidBridge;
    webkit?: IWebkit;
  }
}

interface IMessage {
  type: string;
  data?: unknown;
}

interface IAndroidBridge {
  postMessage: (message: string) => void;
  close: VoidFunction;
}

interface IWebkit {
  messageHandlers: {
    vuddy: {
      postMessage: (params: string) => void;
      close: VoidFunction;
    };
  };
}

interface IPickPhotosOptions {
  /** 한 번에 선택 가능한 최대 사진 개수 */
  maxCount: number;
  /** 'gallery'만 지원 (카메라 옵션 노출 금지) */
  source: 'gallery';
}

interface IPickVideoOptions {
  /** 한 번에 선택 가능한 최대 동영상 개수 (현재는 1만 사용) */
  maxCount: 1;
  /** 'gallery'만 지원 (카메라 옵션 노출 금지) */
  source: 'gallery';
}

interface IWebViewService {
  isAppWebView: (userAgent: string) => boolean;
  getDevicePlatform: (userAgent: string) => DEVICE_PLATFORM;
  refreshToken: VoidFunction;
  close: VoidFunction;
  shareUrl: (url: string) => void;
  postMessage: ({ type, data }: IMessage) => void;
  pickPhotos: (options: IPickPhotosOptions) => void;
  pickVideo: (options: IPickVideoOptions) => void;
}

const isAppWebView = (userAgent: string) => {
  /* vuddy/AOS|iOS/(appVersion)/(languageCode) */
  return /vuddy\/(aos|ios)/i.test(userAgent);
};

const postMessage = ({ type, data }: IMessage) => {
  const message: IMessage = { type, data };
  const messageString = JSON.stringify(message);

  window.AndroidBridge?.postMessage(messageString);
  window.webkit?.messageHandlers?.vuddy?.postMessage(messageString);
};

const webViewService: IWebViewService = {
  isAppWebView,
  getDevicePlatform: userAgent => {
    if (/vuddy\/aos/i.test(userAgent)) {
      return 'AOS';
    } else if (/vuddy\/ios/i.test(userAgent)) {
      return 'IOS';
    } else {
      return 'WEB';
    }
  },
  refreshToken: () => {
    postMessage({ type: 'InvalidateAccessToken' });
  },
  close: () => {
    postMessage({ type: 'Close' });
  },
  shareUrl: (url: string) => {
    postMessage({ type: 'ShareUrl', data: url });
  },
  pickPhotos: (options: IPickPhotosOptions) => {
    postMessage({ type: 'PickPhotos', data: options });
  },
  pickVideo: (options: IPickVideoOptions) => {
    postMessage({ type: 'PickVideo', data: options });
  },
  postMessage,
};

export default webViewService;
